const assignment = {
  assignment: "Devoir",
  create: "Créer un nouveau devoir",
  creation: "Création d'un devoir",
  update: "Modification d'un devoir",
  view: "Visualisation d'un devoir",
  creationInstruction: "Définissez les paramètres de votre devoir.",
  number: "N°",
  name: "Nom",
  lastEdited: "Dernière modification",
  classes: "Classes",
  follow: "Suivre mes devoirs",
  followed: "Suivi des devoirs",
  finishDate: "Date de rendu",
  mandatoryStartDate: "La date de début est obligatoire.",
  mandatoryFinishDate: "La date de rendu est obligatoire.",
  finishDateCondition:
    "La date de rendu doit être postérieure à la date de début et à la date actuelle.",
  save: "Sauvegarder le devoir",
  saveAndPublish: "Sauvegarder et publier le devoir",
  selectExercisesInstruction:
    "Sélectionnez les exercices que vous souhaitez ajouter dans votre devoir en cliquant sur les icônes",
  visualizeHomeworkInstruction:
    "Visualisez votre devoir avant de le sauvegarder.",
  teacherNoHomework: "Vous n'avez pas encore créé de devoir.",
  deleteHomeworkQuestion: "Supprimer ce devoir ?",
  deleteHomeworkDescription:
    "Le devoir ne sera plus disponible. Toutes les données du devoir seront définitivement perdues.",
  notOpened: "Non ouvert",
  notCompleted: "Non complété",
  noGradeNotCompleted: "Non terminé",
  homeworkNotOpened: "Devoir non ouvert",
  homeworkNotFinished: "Devoir non terminé",
  all_levels: "Tous niveaux",
  followMyHomeworks: "Suivre mes devoirs",
  homework: "Devoir",
  mockTest: "Examen blanc",
  mockTestNumber: "Exam blanc N°",
  completeHomework: "Compléter le devoir",
  completeHomeworkAgain: "Compléter à nouveau le devoir",
  mockTestName: "Nom de l'examen blanc : ",
  homeworkName: "Nom du devoir : ",
  homeworkStartDate: "Date de début",
  homeworkFinishDate: "Date de rendu",
  homeworkStatus: "Statut",
  homeworkStartDateWithColon: "Date de début : ",
  homeworkFinishDateWithColon: "Date de rendu : ",
  homeworkStatusWithColon: "Statut : ",
  homeworkStatusComing: "À venir",
  homeworkStatusOngoing: "Ouvert",
  homeworkStatusExpired: "Fermé",
  homeworkNote: "Note : ",
  exerciseList: "Liste des exercices : ",
  emptyHomeworks: "Aucun devoir ne vous est assigné !",
  homeworkNumber: "Devoir N°",
  homeworkNumberColon: "Devoir N°{number} :",
  homeworkCompleted: "Devoir rempli !",
  mockTestCompleted: "Examen blanc rempli !",
  yourMark: "Votre note :",
  backToHomeworks: "Retour à mes devoirs",
  homeworkAttempt: "essai",
  homeworkAttempts: "essais",
  gradeUnfinishedHomeworks: "Noter les devoirs non terminés",
  gradeUnfinishedHomeworksDetails:
    "Les élèves de cette classe qui n'ont pas complété un devoir passé se verront attribuer une note à partir des réponses qu'ils ou elles ont renseignées. Cette action sera appliquée à tous les devoirs non terminés de cette classe. Cette action est irréversible.",
  adminTeacherHomeworks: "Devoirs de l'enseignant",
};

export default assignment;
